import axios from 'axios'
import { userKey } from "@/global"

//const success = res => {
    // switch (res.data.type) {
    //     case 'Tip':
    //         this.$awn.tip(res.data.message, {labels: {success: res.data.title }});
    //         break;
    //     case 'Info':
    //         this.$awn.info(res.data.message, {labels: {success: res.data.title }});
    //         break;
    //     case 'Success':
    //         console.log('entrei no success');
    //         this.$awn.success(res.data.message, {labels: {success: res.data.title }});
    //       break;
    //     case 'Warning':
    //         this.$awn.warning(res.data.message, {labels: {success: res.data.title }});
    //         break;
    //     case 'Alert':
    //         this.$awn.alert(res.data.message, {labels: {success: res.data.title }});
    //         break;
    //     default:          
    //         break;  
    // }
    
//     return res;
// }

const success = res => {
    return res;
}
const error = err => {
    if (401 === err.response.status) {
        window.location = '/login';
        localStorage.removeItem(userKey)
    } else {
        return Promise.reject(err)
    }
}   

axios.interceptors.response.use(success ,error)